import HeaderWidget from '../../header/src/HeaderWidget.vue';

export default HeaderWidget;
